var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProject({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-project-20x20",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,3 L6.07397679,3 C6.65616524,3 7.20945671,3.25368138 7.58939014,3.69480945 L10.0028076,6.49694824 L20,6.49694824 L20,16 C20,17.1045695 19.1045695,18 18,18 L2,18 C0.8954305,18 1.3527075e-16,17.1045695 -4.4408921e-16,16 L-4.4408921e-16,5 C-5.7935996e-16,3.8954305 0.8954305,3 2,3 Z M18.5,7.99694824 L9.31506511,7.99694824 L6.45283013,4.67370236 C6.35784677,4.56342034 6.2195239,4.5 6.07397679,4.5 L2,4.5 C1.72385763,4.5 1.5,4.72385763 1.5,5 L1.5,16 C1.5,16.2761424 1.72385763,16.5 2,16.5 L18,16.5 C18.2761424,16.5 18.5,16.2761424 18.5,16 L18.5,7.99694824 Z M10.4061659,5 L9,4 L16.5938341,4 L18,5 L10.4061659,5 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.1fd5ee420143e9a874624278ec2ed958.svg";
export { ForwardRef as ReactComponent };